import { ApexOptions } from 'apexcharts';
import { PrmStudentEngagementReportResult } from 'types/schema-generated-types';

const colors = ['#FFC20E', '#919191', '#EA031F'];

export const buildOptions = (
  prmStudentEngagementReport: PrmStudentEngagementReportResult
): ApexOptions => ({
  fill: {
    colors
  },
  chart: {
    type: 'bar',
    height: 250,
    stacked: true,
    sparkline: {
      enabled: false
    }
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '40%'
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    colors
  },
  title: {
    text: 'Student Skills Progress',
    style: {
      fontSize: '32px',
      fontWeight: 450
    }
  },
  xaxis: {
    categories: buildCategories(prmStudentEngagementReport),
    title: {
      text: 'Lessons',
      style: {
        fontWeight: 600
      }
    }
  },
  yaxis: {
    min: () => 0,
    max: () => 20,
    forceNiceScale: true,
    title: {
      text: undefined
    }
  },
  grid: {
    xaxis: {
      lines: {
        show: true
      }
    },
    yaxis: {
      lines: {
        show: false
      }
    }
  },

  states: {
    hover: {
      filter: {
        type: 'none'
      }
    }
  },
  legend: {
    position: 'bottom',
    markers: {
      height: 10,
      width: 10,
      fillColors: ['#FFC20E', '#919191', '#EA031F'],
      radius: 12
    }
  }
});

export const buildSeries = (prmStudentEngagementReport: PrmStudentEngagementReportResult) => {
  const base = [
    {
      name: 'Met Skill Needed Support',
      data: []
    },
    {
      name: 'Met Skill Did Not Need Support',
      data: []
    },
    {
      name: 'Skills Not Met',
      data: []
    }
  ];
  const result = prmStudentEngagementReport?.studentCurriculumProgress?.reduce(
    (acc: any, { lessonCompletionStats }: any) => {
      const [metNeededSupport, metDidNotNeedSupport, notMet] = acc;
      metDidNotNeedSupport.data.push(lessonCompletionStats?.metSkillWithoutSupportCount! ?? 0);
      metNeededSupport.data.push(lessonCompletionStats?.metSkillWithSupportCount! ?? 0);
      notMet.data.push(lessonCompletionStats?.unmetSkillCount! ?? 0);
      return acc;
    },
    base
  );

  return result ?? [];
};
const buildCategories = (prmStudentEngagementReport: PrmStudentEngagementReportResult) => {
  return (
    prmStudentEngagementReport?.studentCurriculumProgress?.map(
      x => `${x.student?.firstName} ${x.student?.lastName}`
    ) ?? []
  );
};
